// packages/app/src/apis.ts
import { CatalogClient } from '@backstage/catalog-client';
import { catalogApiRef } from '@backstage/plugin-catalog-react';
import { ApiBlueprint, createFrontendModule } from '@backstage/frontend-plugin-api';
import {
  discoveryApiRef,
  fetchApiRef,
} from '@backstage/core-plugin-api';
import type {
  GetEntitiesRequest,
  GetEntitiesResponse,
  QueryEntitiesRequest,
  QueryEntitiesResponse,
  CatalogRequestOptions,
} from '@backstage/catalog-client';

class FilteredCatalogClient extends CatalogClient {
  async getEntities(
    request?: GetEntitiesRequest,
    options?: CatalogRequestOptions,
  ): Promise<GetEntitiesResponse> {
    const response = await super.getEntities(request, options);
    return {
      ...response,
      items: response.items.filter(
        e => e.kind !== 'Template' || !e.metadata.tags?.includes('hidden'),
      ),
    };
  }

  async queryEntities(
    request?: QueryEntitiesRequest,
    options?: CatalogRequestOptions,
  ): Promise<QueryEntitiesResponse> {
    const response = await super.queryEntities(request, options);
    return {
      ...response,
      items: response.items.filter(
        e => e.kind !== 'Template' || !e.metadata.tags?.includes('hidden'),
      ),
    };
  }
}

// 2026-05-04: This is a workaround for not being able to add custom filtering to the Scaffolder Templates page
// in the new Frontend system yet
export const filteredCatalogApi = ApiBlueprint.make({
  params: defineParams =>
    defineParams({
      api: catalogApiRef,
      deps: {
        discoveryApi: discoveryApiRef,
        fetchApi: fetchApiRef,
      },
      factory: ({ discoveryApi, fetchApi }) =>
        new FilteredCatalogClient({ discoveryApi, fetchApi }),
    }),
});

export const filteredCatalogApiPlugin = createFrontendModule({
  pluginId: 'catalog',
  extensions: [filteredCatalogApi],
});
